export interface SlideDate {
  from: string
  to: string
}

export function SlideDateFromJSON(value: SlideDate): any {
  return {
    from: value.from !== '' ? value.from : undefined,
    to: value.to !== '' ? value.to : undefined
  }
}
